<div *ngIf="googleMapsLoaded">
  <button (click)="switchMapTypeClick(EMapType.ROADMAP)"
    [class.map-type-switcher-control-btn--selected]="mapType === EMapType.ROADMAP"
    class="btn map-type-switcher-control-btn"
    i18n="@@S_MAP">
    Map
  </button>
  <button (click)="switchMapTypeClick(EMapType.HYBRID)"
    [class.map-type-switcher-control-btn--selected]="mapType === EMapType.HYBRID"
    class="btn map-type-switcher-control-btn"
    i18n="@@S_SATELLITE">
    Satellite
  </button>
</div>
